import { v4 as uuidv4 } from 'uuid';

export const products = [
    {
        id: '32b2d6ba-6bf7-479e-8351-6809ed8c7715',
        name: 'Bottle 350ml',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla nec purus feugiat, molestie ipsum et, consequat nibh. Etiam non elit dui. Nulla nec purus feugiat, molestie ipsum et, consequat nibh. Etiam non elit dui.',
        size: 350,
        price: 20,
        images: [
            'https://mockupfree.net/wp-content/uploads/2023/12/03-10-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/12/07-10-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/12/02-9-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/12/09-10-scaled.jpg',
        ],
    },
    {
        id: '5ff8a345-4cea-42bf-b9f7-3beebe6e434e',
        name: 'Bottle 350ml',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla nec purus feugiat, molestie ipsum et, consequat nibh. Etiam non elit dui. Nulla nec purus feugiat, molestie ipsum et, consequat nibh. Etiam non elit dui.',
        size: 350,
        price: 10,
        images: [
            'https://mockupfree.net/wp-content/uploads/2023/12/04-10-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/12/06-10-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/12/01-9-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/12/05-10-scaled.jpg',
        ],
    },
    {
        id: '0be678a4-4041-4f2f-9b68-76e29bd5d07d',
        name: 'Bottle 450ml',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla nec purus feugiat, molestie ipsum et, consequat nibh. Etiam non elit dui. Nulla nec purus feugiat, molestie ipsum et, consequat nibh. Etiam non elit dui.',
        size: 450,
        price: 45,
        images: [
            'https://mockupfree.net/wp-content/uploads/2023/04/01-8-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/04/02-8-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/04/07-7-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/04/05-9-scaled.jpg',
        ],
    },
    {
        id: 'edc87e1e-c4e9-4675-b74b-351d8feeb269',
        name: 'Bottle 450ml',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla nec purus feugiat, molestie ipsum et, consequat nibh. Etiam non elit dui. Nulla nec purus feugiat, molestie ipsum et, consequat nibh. Etiam non elit dui.',
        size: 450,
        price: 50,
        images: [
            'https://mockupfree.net/wp-content/uploads/2023/09/01-5-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/09/04-4-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/09/07-4-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/09/05-4-scaled.jpg',
        ],
    },
    {
        id: '4ae2eb9c-b9e9-4852-b218-1c71716099c4',
        name: 'Bottle 600ml',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla nec purus feugiat, molestie ipsum et, consequat nibh. Etiam non elit dui. Nulla nec purus feugiat, molestie ipsum et, consequat nibh. Etiam non elit dui.',
        size: 600,
        price: 30,
        images: [
            'https://mockupfree.net/wp-content/uploads/2023/05/2-2-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/05/3-2-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/05/4-2-scaled.jpg',
            'https://mockupfree.net/wp-content/uploads/2023/05/5-2-scaled.jpg',
        ],
    }
];
